// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "build/" + chunkId + "." + {"88":"563abd0f7a39a83c5e47","430":"93569205a1deba2a6243"}[chunkId] + ".js";
};